module.exports = __webpack_public_path__ + "static/media/HTB.f90ced6d.svg";